import { render } from "./ProductivityHeatmap.vue?vue&type=template&id=48a51d2b"
import script from "./ProductivityHeatmap.vue?vue&type=script&lang=js"
export * from "./ProductivityHeatmap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__